import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Framework/helpers/BreakpointHelper";
import { Link } from "BaseComponents/Link/Link";

export const BreadcrumbsLink = styled(Link)`
	margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : "")};
	font-size: 18px;
	font-weight: bold;
	line-height: 26px;
	${media.greaterThan(breakpoints.mobile)`
		color: ${({ theme }) => theme.colors.primary};
	`}
	${media.lessThan(breakpoints.mobile)`
    	font-weight: bold;
	`}
`;

export const BreadcrumbsLinkContainer = styled.div`
	display: flex;
	align-items: center;
	background-color: ${({ bgColor }) => (bgColor ? bgColor : "")};
	margin: ${(margin) => margin};

	${media.greaterThan(breakpoints.mobile)`
        font-weight: ${({ first }) => (first ? "bold" : "")};
	
    `}
`;

export const BreadcrumbsWrapper = styled.div`
	background-color: ${({ bgColor }) => (bgColor ? bgColor : "")};

	max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "")};
	display: flex;
	transition: 0.2s ease;
	flex-direction: column;
`;
